import { Link } from "react-router-dom";
import { useI18n } from "@/i18n/I18nProvider";
import { SEO } from "@/components/SEO";

export function NotFoundPage() {
  const { lang, prefix } = useI18n();
  const isSv = lang === "sv";
  return (
    <div className="container-page py-16">
      <SEO
        title={isSv ? "Sidan hittades inte" : "Page not found"}
        description={isSv ? "404 – sidan finns inte." : "404 — page not found."}
        noindex
      />
      <h1 className="text-4xl font-extrabold">404</h1>
      <p className="mt-2 text-ink-700">
        {isSv
          ? "Sidan finns inte. Använd menyn eller gå till startsidan."
          : "The page was not found. Use the menu or return to the homepage."}
      </p>
      <Link className="btn-primary mt-4" to={prefix}>
        {isSv ? "Till startsidan" : "Go to homepage"}
      </Link>
    </div>
  );
}
